"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var __1 = require("../");
var App = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(__1.MapView, null),
        React.createElement(__1.Sidebar, null,
            React.createElement(__1.Search, null),
            React.createElement("div", { className: 'leader-half trailer-0' },
                React.createElement("span", { className: 'font-size--3' }, "Active wildfires by affected area (in acres)"),
                React.createElement("span", { className: 'js-modal-toggle icon-ui-description margin-left-half font-size-0 cursor-pointer right', "data-modal": "about" })),
            React.createElement(__1.Legend, null),
            React.createElement(__1.SmokeLayerToggle, null),
            React.createElement(__1.ListModeToggle, null),
            React.createElement(__1.ListView, null)),
        React.createElement(__1.AboutThisApp, null)));
};
exports.default = App;
